import { render, staticRenderFns } from "./PopupSlotComponent.vue?vue&type=template&id=ed26a4c0&scoped=true&"
import script from "./PopupSlotComponent.vue?vue&type=script&lang=js&"
export * from "./PopupSlotComponent.vue?vue&type=script&lang=js&"
import style0 from "./PopupSlotComponent.vue?vue&type=style&index=0&id=ed26a4c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed26a4c0",
  null
  
)

export default component.exports